export const SERVICES_TYPE = {
	REPORTS: 'reports',
	REPORTS_EXTRA: 'reports-extras',
	TIER: 'tier',
	BI: 'bi',
	OFFICE_GROUP: 'offices_group',
    SITE_GROUP: 'sites_group',
	ACRISS_GROUP: 'acriss_group',
	WEB_SUPPLIER_GROUP: 'web_supplier_group',
	PROVIDER_COLOR: 'provider_color',
	SITE_COLOR: 'site_color',
	CATEGORY_COLOR: 'category_color',
	ACRISS_COLOR: 'acriss_color',
}

export const FEATURES_TYPE = {
	ADMIN: 'admin',
	COMMON: 'common',
	BI: 'bi',
	BATCH: 'batch',
	REPORTS_EXTRA: 'reports-extras',
	LEADING: 'leading_price',
	EUROPCAR: 'europcar',
	REPORT_GROUPS: 'reportGroups',
	AUTOEUROPE: 'autoeurope',
	MY_BUSINESS: 'my_business',
	MY_BUSINESS_ADMIN: 'my_business_admin',
	DS_REPRICING: 'ds_repricing',
	ONE_WAY: 'one_way',
	NEWS_MANAGEMENT: 'news_management',
}